module.exports = __webpack_public_path__ + "static/media/Screen-Shot-2019-11-26-at-1.47.32-PM-300x169.199a72b7.png";